import React from 'react';
import Spinner from '../Spinner/index.jsx';

class PopularArticles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      fetching: false,
      articles: [],
      error: undefined,
      canPage: true
    };

    this.fetchComplete = this.fetchComplete.bind(this);
    this.fetchError = this.fetchError.bind(this);
    this.fetchPage = this.fetchPage.bind(this);
  }
  /**
   * retrieve the first 'page' of articles.
   */
   componentDidMount() {
    this.fetchPage()
   }
   fetchPage() {
    if (! this.state.fetching) {
      this.setState({ fetching: true, canPage: true });
      this.props.mostPopularArticles.fetchPage()
        .then(this.fetchComplete)
        .catch(this.fetchError);
    }
  }

  fetchComplete(articles) {
    this.setState(function(oldState) {
      return {
        articles: oldState.articles.concat(articles),
        canPage: (articles.length > 0),
         fetching: false
      };
    });
  }

  fetchError(error) {
    this.setState({ error: error, fetching: false });
  }

  render() {
    var ArtilcesLists = this.state.articles;
    const articleList = ArtilcesLists.map((ArtilcesList, index) => (
      <li key={index}><a href={ArtilcesList.permalink}>
        {ArtilcesList.title} ({ArtilcesList.pageviews})</a>
      </li>
    ));
    
    return (
      <>
        {this.state.fetching?( <Spinner/> ):(articleList)}
      </>
    );
  }

}

export default PopularArticles;
